import { useApi } from './useApi';
import { url } from '../../utils/confserveur';

export const useSessionQCM = (id, refresh) => {
  const enabled = id ? undefined : 'not-enabled';
  return useApi(`${url}sessions-qcm/${id}/`, {}, refresh, enabled);
};
